import { useRef, useState } from 'react';
import { Switch } from '../ui/switch';

interface Props {
    hidden?: boolean;
    readOnly: boolean;
    onChange: (hidden: boolean) => Promise<void>;
}

export function MerchantApiVisibilitySwitch({ hidden = false, readOnly, onChange }: Props) {
    const savingRef = useRef(false);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const toggle = async (next: boolean) => {
        if (readOnly || savingRef.current) return;
        savingRef.current = true;
        setSaving(true);
        setError(null);
        try {
            await onChange(next);
        } catch (err: any) {
            const detail = err.response?.data?.detail;
            setError(typeof detail === 'string' ? detail : 'Не удалось изменить видимость API-ключей');
        } finally {
            savingRef.current = false;
            setSaving(false);
        }
    };

    return <div className="px-6 pb-3" aria-busy={saving}>
        <label className="flex items-center gap-2 text-sm">
            <Switch aria-label="Скрывать API-ключи" checked={hidden} disabled={readOnly || saving} onCheckedChange={toggle} />
            Скрывать API-ключи
            {saving && <span role="status" className="text-xs text-slate-500">Сохранение…</span>}
        </label>
        <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">Скрывает раздел «API и интеграция» в кабинете мерчанта.</p>
        {error && <p role="alert" className="mt-2 text-sm text-red-600 dark:text-red-400">{error}</p>}
    </div>;
}
